module.exports = __webpack_public_path__ + "media/custom/images/img13-babdaefe0f7e62d8f6f11292150a188e.png";